import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { UnitOfWorkService } from '../../services/unitOfWork/unitOfWork.service';
import * as _util from '../../services/utilities';
import * as _errorHandler from '../../services/errorhandler';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { saveAs } from 'file-saver';
import { BusyService } from '../../services/busy.service';

@Component({
  selector: 'app-download',
  templateUrl: './download.component.html'
})
export class DownloadComponent implements OnInit, OnDestroy {

    library: string;
    id: number;
    sub: Subscription;
    doc: model.document;

    handler = _errorHandler.includeIn(this);

    constructor(private route: ActivatedRoute, private router: Router, private http: HttpClient, @Inject('BASE_URL') private baseUrl: string, private busy: BusyService) { }

    ngOnInit() {
        this.sub = this.route.params.subscribe(params => {
            this.library = params["library"];
            this.id = +params["id"];
            this.busy.set({ key: 'file-download', isBusy: true, message: 'Downloading file' });

            this.http.get(this.baseUrl + 'breeze/documentDownload?library=' + this.library + '&id=' + this.id, { observe: 'response', responseType: 'blob' })
                .toPromise().then(resp => {
                    saveAs(resp.body, resp.headers.get('X-Bdo-FileName'), {
                        type: resp.body.type
                    });
                    this.busy.set({ key: 'file-download', isBusy: false });
                }).catch(ex => {
                    this.busy.set({ key: 'file-download', isBusy: false });
                    this.handler.handleError(ex);
                }).then(a => {
                    this.router.navigate(['/document', this.library, this.id]);
                })
        });
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

}
